module.exports = __webpack_public_path__ + "img/profile-2user.646af8fe.svg";